import type { WordPackDefinition } from "./types";

// Geography pack - countries, cities, landmarks, terrain
export const GEOGRAPHY_WORDS = [
  // Countries & Regions
  "ICELAND", "BRAZIL", "JAPAN", "KENYA", "NORWAY", "PERU", "SPAIN", "VIETNAM", "IRELAND", "MOROCCO",
  "SWEDEN", "CHILE", "POLAND", "THAILAND", "PORTUGAL", "ARGENTINA", "KOREA", "FINLAND", "CUBA", "NEPAL",
  "SCOTLAND", "SINGAPORE", "TAIWAN", "JAMAICA", "SWITZERLAND", "AUSTRIA", "BELGIUM", "DENMARK", "UKRAINE", "COLOMBIA",
  // Cities
  "PARIS", "CAIRO", "DUBAI", "SYDNEY", "VENICE", "PRAGUE", "VIENNA", "ATHENS", "LISBON", "MUNICH",
  "BOSTON", "SEATTLE", "MIAMI", "DENVER", "CHICAGO", "DALLAS", "PHOENIX", "PORTLAND", "MONTREAL", "TORONTO",
  "BARCELONA", "AMSTERDAM", "BUDAPEST", "FLORENCE", "NAPLES", "MILAN", "OSLO", "STOCKHOLM", "DUBLIN", "EDINBURGH",
  "HAVANA", "BANGKOK", "MANILA", "SEOUL", "SHANGHAI", "MUMBAI", "DELHI", "ISTANBUL", "JERUSALEM", "MECCA",
  // Landmarks & Wonders
  "EIFFEL", "COLOSSEUM", "TAJ MAHAL", "STONEHENGE", "PARTHENON", "KREMLIN", "ACROPOLIS", "SPHINX", "PANTHEON", "PAGODA",
  "NOTRE DAME", "BIG BEN", "LOUVRE", "VATICAN", "VERSAILLES", "ALHAMBRA", "PETRA", "ANGKOR", "MACHU PICCHU", "EASTER ISLAND",
  // Natural Features
  "SAHARA", "CANYON", "VOLCANO", "DELTA", "FJORD", "GLACIER", "GEYSER", "REEF", "CAPE", "BAY",
  "PENINSULA", "STRAIT", "LAGOON", "PLATEAU", "BASIN", "TUNDRA", "STEPPE", "SAVANNA", "RAINFOREST", "ARCHIPELAGO",
  "DUNE", "OASIS", "GORGE", "ATOLL", "MARSH", "PRAIRIE", "MESA", "BUTTE", "COVE", "INLET",
  // Rivers & Bodies of Water
  "NILE", "DANUBE", "RHINE", "THAMES", "GANGES", "YANGTZE", "MEKONG", "TIGRIS", "EUPHRATES", "ZAMBEZI",
  "CARIBBEAN", "MEDITERRANEAN", "PACIFIC", "ATLANTIC", "ARCTIC", "INDIAN OCEAN", "BLACK SEA", "RED SEA", "BALTIC", "ADRIATIC",
  // Mountains & Ranges
  "EVEREST", "KILIMANJARO", "FUJI", "MATTERHORN", "VESUVIUS", "ETNA", "ANDES", "ROCKIES", "PYRENEES", "CAUCASUS",
  "APPALACHIAN", "SIERRA", "ATLAS", "URALS", "CARPATHIAN", "DOLOMITES", "OLYMPUS", "SINAI", "DENALI", "ACONCAGUA",
  // Geographic Terms
  "EQUATOR", "MERIDIAN", "TROPIC", "LATITUDE", "LONGITUDE", "HEMISPHERE", "CONTINENT", "BORDER", "TERRITORY", "PROVINCE",
  "COMPASS", "GLOBE", "MAP", "CARTOGRAPHER", "EXPEDITION", "FRONTIER", "COLONY", "EMPIRE", "KINGDOM", "REPUBLIC",
  // Islands
  "HAWAII", "BALI", "SICILY", "CRETE", "CORSICA", "SARDINIA", "CYPRUS", "MALTA", "FIJI", "TAHITI",
  "BAHAMAS", "BARBADOS", "CANARY", "GALAPAGOS", "MADAGASCAR", "ZANZIBAR", "BORNEO", "SUMATRA", "JAVA", "MAURITIUS",
];

export const GEOGRAPHY_SEMANTIC_FAMILIES: string[][] = [
  ["ICELAND", "NORWAY", "SWEDEN", "FINLAND", "DENMARK"],
  ["JAPAN", "KOREA", "THAILAND", "VIETNAM", "TAIWAN", "SINGAPORE"],
  ["PARIS", "VIENNA", "PRAGUE", "BUDAPEST", "AMSTERDAM", "LISBON", "BARCELONA", "MILAN"],
  ["NILE", "DANUBE", "RHINE", "THAMES", "GANGES", "YANGTZE", "MEKONG"],
  ["PACIFIC", "ATLANTIC", "ARCTIC", "INDIAN OCEAN", "MEDITERRANEAN", "CARIBBEAN"],
  ["EVEREST", "KILIMANJARO", "FUJI", "MATTERHORN", "DENALI", "ACONCAGUA"],
  ["CANYON", "VOLCANO", "DELTA", "FJORD", "GLACIER", "REEF", "LAGOON", "PLATEAU", "OASIS", "COVE", "INLET"],
  ["EQUATOR", "MERIDIAN", "LATITUDE", "LONGITUDE", "HEMISPHERE", "CONTINENT", "MAP", "COMPASS", "GLOBE", "CARTOGRAPHER"],
  ["HAWAII", "BALI", "SICILY", "CYPRUS", "FIJI", "TAHITI", "GALAPAGOS", "MADAGASCAR", "JAVA"],
];

export const GEOGRAPHY_PACK: WordPackDefinition = {
  key: "geography",
  words: GEOGRAPHY_WORDS,
  semanticFamilies: GEOGRAPHY_SEMANTIC_FAMILIES,
};
